export const LATEST_TRANSACTIONS_TABLE_PT_BR = {
	title: "Últimos saques e antecipações",
	date: "Data de solicitação",
	paymentDate: "Data de pagamento",
	status: "Status",
	type: "Tipo",
	value: "Valor",
	actions: "Ações",
	requester: "Solicitante",
	prorata: "Pró rata",
	refused: "Recusado",
	pixKey: "Chave PIX",
	reason: "Motivo",
	requestReason: "Motivo",
	refusalReason: "Motivo da recusa",
	favorecido: "Favorecido",
	dataInicial: "Data inicial",
	dataFinal: "Data final",
	at: "às",
	contaPropria: "Conta própria",
	placeDestino: "Place de destino",
	beneficiarioBoleto: "Beneficiário do boleto",
	back: "Voltar",
	withdrawal: "Saque",
	anticipation: "Antecipação",
	detailsTitle: "Detalhes da transação",
	filename: "saques-antecipacoes-boletos",
	accountHolder: "Titular da Conta",
	accountType: "Tipo de Conta",
	agency: "Agência",
	account: "Conta",
	bankName: "Nome do Banco",
	accountName: "Nome da Conta",
	cancelWithdraw: "Cancelar saque",
	viewDetails: "Ver detalhes",
	cancelConfirmTitle: "Cancelar saque",
	cancelConfirmDescription:
		"Tem certeza que deseja cancelar este saque? Esta ação não pode ser desfeita.",
	confirmCancel: "Sim, cancelar",
	internalObservation: "Observações",
	table: {
		datetime: "Data de solicitação",
		paymentDate: "Data de pagamento",
		type: "Tipo",
		status: "Status",
		username: "Usuário",
		vendor: "Vendor",
		requestedValue: "Valor solicitado",
		liquidAnticipatedValue: "Valor antecipado",
		proRataFee: "Pró rata",
		appliedFee: "Taxa aplicada",
		proRataFeeTooltip: "Taxa de antecipação proporcional ao período do saldo a antecipar",
		totalBruteValue: "Valor bruto total",
		bankAccount: "Conta bancária",
		ticketPayment: "Pagamento de boleto",
		clientObservation: "Motivo",
		obs: "Observação",
		paymentMethod: "Método de pagamento",
		attachments: "Anexos",
		confirmWithdrawBtnLabel: "Confirmar solicitação",
	},
	transactionLink: "Link de transação",
	filterByType: "Filtrar por tipo",
	allTypes: "Todos os tipos",
	typeWithdraw: "Saque",
	typeAnticipation: "Antecipação",
	typeTicketPayment: "Pagamento de boleto",
	typeTransferBetweenPlaces: "Transferência entre Places",
	// Traduções para saques recusados e relacionados
	viewOriginalWithdraw: "Ver saque original",
	viewNewWithdraw: "Ver novo saque",
	originalWithdrawRequest: "Solicitação Original",
	newWithdrawRequest: "Nova Solicitação",
	withdrawDeclinedTitle: "Saque Recusado por Saldo Insuficiente",
	withdrawDeclinedMessage:
		"Este saque foi recusado automaticamente porque o saldo disponível era insuficiente no momento da aprovação. Um novo saque foi criado com o valor disponível.",
	thisIsNewWithdraw: "Este é o novo saque criado após a recusa do saque original.",
	thisIsDeclinedWithdraw: "Este saque foi recusado e um novo saque foi criado.",
	retryPixReceipt: "Gerar novo comprovante",
	retryPixReceiptSuccess: "Comprovante gerado com sucesso!",
	retryPixReceiptError: "Erro ao gerar novo comprovante",
	receiptNotAvailable: "Comprovante não disponível",
};

export type LatestTransactionsTableTranslations = typeof LATEST_TRANSACTIONS_TABLE_PT_BR;
